/** Lernzeit (Roadmap F-22, Stufe 7): Stoppuhr und Nachtragen. */
import { db } from '@/db/schema';
import { inDenPapierkorb } from '@/db/repositories/papierkorb';
import { nowInstant } from '@/lib/datetime';
import { newId } from '@/lib/utils/id';
import type { ID, LocalDate, StudySession } from '@/domain/types';

/** Die laufende Sitzung, falls es eine gibt. */
export async function laufendeSitzung(): Promise<StudySession | undefined> {
  return db.studySessions.filter((s) => !s.end).first();
}

/** Startet die Stoppuhr - eine schon laufende wird vorher beendet. */
export async function starteLernzeit(subjectId: ID): Promise<StudySession> {
  return db.transaction('rw', db.studySessions, async () => {
    const ts = nowInstant();
    await db.studySessions.filter((s) => !s.end).modify({ end: ts });
    const s: StudySession = { id: newId(), subjectId, start: ts, createdAt: ts };
    await db.studySessions.add(s);
    return s;
  });
}

export async function stoppeLernzeit(): Promise<void> {
  await db.studySessions.filter((s) => !s.end).modify({ end: nowInstant() });
}

/** Nachtragen: Minuten an einem Tag (Beginn 12:00 lokal, damit der Tag stimmt). */
export async function lernzeitNachtragen(subjectId: ID, datum: LocalDate, minuten: number): Promise<StudySession | null> {
  if (!(minuten > 0) || minuten > 24 * 60 || !datum) return null;
  const [j, m, t] = datum.split('-').map(Number) as [number, number, number];
  const start = new Date(j, m - 1, t, 12, 0, 0);
  const s: StudySession = {
    id: newId(),
    subjectId,
    start: start.toISOString(),
    end: new Date(start.getTime() + minuten * 60000).toISOString(),
    createdAt: nowInstant(),
  };
  await db.studySessions.add(s);
  return s;
}

export async function deleteLernzeit(id: ID): Promise<void> {
  await inDenPapierkorb({ art: 'geloescht', tabelle: 'studySessions', zeileIds: [id], titel: 'Lernzeit' }, () => db.studySessions.delete(id));
}
